<template>
  <div class="appWrap" :class="[`dev-${deviceMode}`]">
    <Suspense>
      <el-config-provider :locale="zhCn">
        <router-view />
      </el-config-provider>
    </Suspense>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, onBeforeUnmount } from 'vue'
import { getAuthInfo, isInModule } from '@/utils.js'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { ElConfigProvider } from 'element-plus'

const deviceMode = computed(() => mm.store.state.deviceMode)
const fontList = ref()
// 初始化
mm.init()
mm.store.commit('SET_USER_INFO', mm.utils.getCookie() || {})

mm.dispatch('GetPageList')
mm.dispatch('GetWidgetsList')
mm.dispatch('GetCollectList')
if (getAuthInfo().type !== 'module') {
  mm.dispatch('GetModuleList')
}

// 页面
if (!isInModule()) {
  mm.dispatch('GetPageDetail', {}).finally(() => {})
}
// 模块
else {
  mm.dispatch('GetModuleDetail')
}

onMounted(() => {
  mm.http({ url: '/api/font/list', method: 'get' }).then((res) => {
    const { data } = res
    const value = JSON.parse(JSON.stringify(data.list))
    // fontList.value = data.list
    injectFonts(value)
  })

  // 动态生成字体的方法
  const injectFonts = (fontList) => {
    const style = document.createElement('style')
    style.type = 'text/css'

    fontList.forEach((font) => {
      style.innerHTML += `
      @font-face {
        font-family: '${font.name}';
        src: url('${font.url}') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `
    })
    document.head.appendChild(style)
  }

  const script = document.createElement('script')
  script.src = './ckeditor/ckeditor.js'
  document.body.appendChild(script)
})
onBeforeUnmount(() => {})
</script>
<style lang="scss">
.appWrap {
  &.dev-diannao {
  }
}

iframe {
  height: 100%;
}
</style>
